import {Pipe, PipeTransform} from '@angular/core';
import {Utils} from '../shared/utils/utils';
import {DateTime} from 'luxon';

@Pipe({
  name: 'currentWeekdays',
})
export class CurrentWeekdays implements PipeTransform {
  transform(value: string): string {
    const inputDate = Utils.formatStringToDateTime(value);
    if (Utils.isToday(inputDate)) {
      return 'Today';
    }
    const today = DateTime.now().startOf('day');
    const startOfWeek = today.startOf('week');
    const endOfWeek = today.endOf('week');
    return inputDate >= startOfWeek && inputDate <= endOfWeek
      ? inputDate.toFormat('cccc')
      : value;
  }
}
